<template>
        <section class="hero-section">
            <div class="hero-overlay"></div>
            <div class="hero-content">
                <h1 class="title-serif">
                    The Art of Afro-Chic
                </h1>
                <p style="color: white;">
                    Celebrating texture, tradition, and modern style through expert braiding, wigs, and holistic care.
                </p>
                <router-link :to="{name: 'services'}"> 
                <div class="btn btn-primary">
                    Book Your Transformation 
                </div>
                </router-link>
            </div>
        </section>
</template>

<script>
export default {
    name: "Intro",
}
</script>

<style scoped>
:root {
            --color-dark: #1c1917;    /* heritage-dark (Stone 900) */
            --color-gold: #FBBF24;    /* heritage-gold (Amber 400) */
            --color-maroon: #5D0E1F;  /* heritage-maroon (Deep Berry/Maroon) */
            --color-light: #f5f5f4;   /* heritage-light (Stone 100) */
            --color-gray: #4b5563;    /* text-gray-600 equivalent */

            --font-sans: 'Inter', sans-serif;
            --font-serif: 'Playfair Display', serif;
        }

.btn {
            display: inline-block;
            font-weight: 700;
            border-radius: 9999px; /* rounded-full */
            box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05); /* shadow-xl/2xl */
            transition: all 0.3s ease;
            cursor: pointer;
        }
        
        .btn-primary {
            background-color: #FBBF24;
            color: #1c1917;
            padding: 1rem 2.5rem; /* px-10 py-4 */
            font-size: 1.25rem; /* text-xl */
        }
        .btn-primary:hover {
            background-color: #fcd34d; /* amber-300 */
            transform: scale(1.02);
        }
        .btn-primary:active {
            transform: scale(0.95);
        }
.hero-section {
            position: relative;
            background-image: url(https://placehold.co/1200x800/292524/FBBF24?text=Stunning+Braids+%26+Styles);
            background-size: cover;
            background-position: center;
            height: 70vh;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 1rem;
        }
        .hero-overlay {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            background-color: rgba(28, 25, 23, 0.6);
        }
        .hero-content {
            position: relative;
            text-align: center;
            max-width: 64rem;
        }
        .hero-content h1 {
            font-size: 3rem; /* text-5xl */
            line-height: 1.2;
            color: white;
            margin-bottom: 1.5rem;
            font-weight: 900; /* black */
        }
        .hero-content p {
            font-size: 1.25rem; /* text-xl */
            margin-bottom: 2.5rem;
            font-weight: 500;
        }
        /* Mobile adjustments for H1 */
        @media (min-width: 640px) {
            .hero-content h1 { font-size: 4.5rem; } /* sm:text-7xl */
        }
        @media (min-width: 1024px) {
            .hero-content h1 { font-size: 6rem; } /* lg:text-8xl */
        }
        .title-serif {
            font-family: var(--font-serif);
            font-weight: 700; /* bold */
        }
</style>


